import {useGSAP} from '@gsap/react'
import gsap from 'gsap'
import {useEffect, useRef, useState} from 'react'
import {RenderCount} from './RenderCount'
import {WaveItem} from './WaveItem'

interface WaveButtonProps {
  onClick: () => void
  renderCount: number
}

export const WaveButton = ({onClick, renderCount}: WaveButtonProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const timeline = useRef(gsap.timeline({paused: true}))

  useGSAP(() => {
    timeline.current.to(ref.current, {
      scale: 1.05,
      duration: 0.2,
    })
    timeline.current.to(ref.current, {scale: 1, duration: 0.2})
  })

  const [waves, setWaves] = useState<number[]>([])

  const onRemoveWave = (id: number) => setWaves(prev => prev.filter(i => i !== id))

  useEffect(() => {
    const listener = () => {
      onClick()
      timeline.current.restart()
      setWaves(prev => [...prev, Date.now()])
    }

    document.addEventListener('pointerdown', listener)

    return () => {
      document.removeEventListener('pointerdown', listener)
    }
  }, [onClick])

  return (
    <div
      ref={ref}
      id="click-button"
      className="relative h-64 w-64 rounded-full bg-[rgb(7,18,68)] shadow-[0_0px_21px_-7px] shadow-white"
    >
      {waves.map(id => (
        <WaveItem key={id} onComplete={() => onRemoveWave(id)} />
      ))}
      <RenderCount renderCount={renderCount} />
    </div>
  )
}
